import React, { useContext, useEffect } from 'react'
import track from '../../lib/track'
import leadAttribution from '../../lib/attribution'
import { useForm, ValidationError } from '@formspree/react'
import { LanguageContext } from '../LanguageSwitcher/LanguageContext'
import checkicon from '../../images/checkicon.svg'
import './QuoteForm.scss'

// Short lead form that sits in the homepage hero. Deliberately kept to four
// fields — the full brief (budget, phone) lives on the contact page.
// Posts to the same Formspree form as the contact page, so every enquiry
// lands in one inbox.
//
// Service, industry and case study pages reuse it in their closing section,
// passing `source` / `subject` / `topic` so the email says which page the
// visitor was reading when they wrote.
const QuoteForm = ({
  source = 'Homepage — free estimate form',
  subject = 'New project enquiry from the homepage',
  topic = '',
  formName = 'home',
  need = 0,
}) => {
  const [state, handleSubmit] = useForm('myzkobag', { data: leadAttribution() })
  const { translations } = useContext(LanguageContext)

  useEffect(() => {
    if (state.succeeded) track('quote_submitted', { form: formName })
  }, [state.succeeded, formName])

  const needOptions = [
    translations.quoteNeed1,
    translations.quoteNeed2,
    translations.quoteNeed3,
    translations.quoteNeed4,
    translations.quoteNeed5,
    translations.quoteNeed6,
    translations.quoteNeed7,
  ]

  if (state.succeeded) {
    return (
      <div className='quote-form-card quote-form-success' id='get-estimate'>
        <img src={checkicon} alt='' className='quote-form-success-icon' />
        <h2 className='quote-form-success-title'>{translations.quoteSuccessTitle}</h2>
        <p className='quote-form-success-txt'>{translations.quoteSuccessText}</p>
        <a className='quote-form-success-link' href='/contact-us'>
          {translations.quoteSuccessLink} <span>→</span>
        </a>
      </div>
    )
  }

  return (
    <div className='quote-form-card' id='get-estimate'>
      <h2 className='quote-form-title'>{translations.quoteTitle}</h2>
      <p className='quote-form-sub'>{translations.quoteSub}</p>

      <form className='quote-form' onSubmit={handleSubmit}>
        {/* Context for whoever reads the submission */}
        <input type='hidden' name='source' value={source} />
        <input type='hidden' name='_subject' value={subject} />
        {topic && <input type='hidden' name='page topic' value={topic} />}

        <div className='quote-form-row'>
          <div className='quote-form-field'>
            <label htmlFor='quote-name'>{translations.quoteName}</label>
            <input id='quote-name' type='text' name='name' autoComplete='name' required />
          </div>
          <div className='quote-form-field'>
            <label htmlFor='quote-email'>{translations.quoteEmail}</label>
            <input id='quote-email' type='email' name='email' autoComplete='email' required />
            <ValidationError prefix='Email' field='email' errors={state.errors} className='quote-form-error' />
          </div>
        </div>

        <div className='quote-form-field'>
          <label htmlFor='quote-need'>{translations.quoteNeed}</label>
          <select id='quote-need' name='what you need' defaultValue={needOptions[need] || needOptions[0]}>
            {needOptions.map((option) => (
              <option key={option} value={option}>{option}</option>
            ))}
          </select>
        </div>

        <div className='quote-form-field'>
          <label htmlFor='quote-message'>{translations.quoteMessage}</label>
          <textarea
            id='quote-message'
            name='message'
            rows={3}
            placeholder={translations.quoteMessagePlaceholder}
            required
          />
          <ValidationError prefix='Message' field='message' errors={state.errors} className='quote-form-error' />
        </div>

        <button type='submit' className='quote-form-btn' disabled={state.submitting}>
          {state.submitting ? translations.quoteSending : translations.quoteSubmit}
        </button>

        <ValidationError errors={state.errors} className='quote-form-error' />

        <p className='quote-form-note'>{translations.quoteNote}</p>
      </form>
    </div>
  )
}

export default QuoteForm
